import { DailyBillingSetting } from "../../classes";

const DailyBillingSettingModule = {
  namespaced: true,
  state: {
    dailyBillingSettings: []
  },
  actions: {
    createDailyBillingSetting: async ({ commit, dispatch, rootGetters }, payload) => {
      try {
        payload.accountingProductId = payload.accountingProductId
        payload.cost = parseFloat(payload.cost)
        payload.discount = parseFloat(payload.discount)
        payload.originalDiscount = parseFloat(payload.originalDiscount)
        payload.marketId = rootGetters["markets/getMarketId"]
        const data = await DailyBillingSetting.createDailyBillingSetting(payload);
        dispatch("getDailyBillingSettings", { areaId: payload.areaId, currencyCode: payload.currencyCode });
        return data;
      } catch (err) {

        throw err;
      }
    },
    getDailyBillingSettings: async ({ commit }, payload) => {
      try {
        const data = await DailyBillingSetting.getDailyBillingSettings(payload);
        commit("setDailyBillingSettings", { dailyBillingSettings: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateDailyBillingSetting: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const dataNormalization = {
          id: payload.id,
          accountingProductId: payload.accountingProductId,
          type: payload.type,
          cost: parseFloat(payload.cost),
          discountType: payload.discountType,
          discount: parseFloat(payload.discount),
          originalDiscount: parseFloat(payload.originalDiscount),
        };
        const data = await DailyBillingSetting.updateDailyBillingSetting(
          dataNormalization
        );
        dispatch("getDailyBillingSettings", { areaId: payload.area.objectId, currencyCode: payload.currencyCode });
        return data;
      } catch (err) {
        return false;
      }
    },
    removeDailyBillingSetting: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const id = payload.id;
        const { data, status } = await DailyBillingSetting.removeDailyBillingSetting({
          id: id
        });
        return data;
      } catch (err) {
        return false;
      }
    },
    getDailyBillingSettingsByAreas: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await DailyBillingSetting.getDailyBillingSettingsByAreas(payload);
        commit("setDailyBillingSettings", { dailyBillingSettings: data });
        return data;
      } catch (err) {
        return false;
      }
    },
    getDailyBillingSettingsByMeters: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await DailyBillingSetting.getDailyBillingSettingsByMeters(payload);
        commit("setDailyBillingSettings", { dailyBillingSettings: data });
        return data;
      } catch (err) {
        return false;
      }
    },
  },
  getters: {
    getDailyBillingSettings :state => state.dailyBillingSettings,
    getDailyBillingSettingsWithLabel: state => {
      return state.dailyBillingSettings.map(item => {
        if (item.accountingProduct) {
          item.accountingProductId = item.accountingProduct.objectId;
          return item
        }
      });
    }
  },
  mutations: {
    setDailyBillingSettings: (state, payload) => {
      state.dailyBillingSettings = payload.dailyBillingSettings;
    }
  }
};

export default DailyBillingSettingModule;
